import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const CreateUserInOrganization = {
  name: 'createUserInOrganization',
  state: {
    data: {},
    loading: false,
    error: '',
    message: '',
  },
  reducers: {
    createRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: '',
      };
    },

    createSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
        message: 'User added to organization successfully!',
      };
    },

    createFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
        message: '',
      };
    },

    clearStatus(state) {
      return {
        ...state,
        error: '',
        message: '',
      };
    },
  },
  effects: (dispatch) => ({
    async addUserToOrganization(userData) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const user_id = userInfo?.id;

        if (!user_id) {
          throw new Error('User ID is required for this operation.');
        }

        const payload = {
          org_id: userInfo?.org_id,
          user: userData,
          origin: window.location.origin,
        };

        this.createRequested();

        const response = await http.post(
          `savvy/organization/user-creation`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              'user_id': user_id,
            },
          }
        );
        if (userInfo?.organization.type === 'ADV')
          dispatch.ProgressStepAdv.UpdateGetADVProgressStep(3);
        if (userInfo?.organization.type === 'DSO')
          dispatch.ProgressStepDSO.UpdateGetDSOProgressStep(6);

        this.createSucceeded(response.data);


        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'User added to organization successfully!',
            show: true,
          },
        });
      } catch (error) {
        this.createFailed(error?.response?.data?.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },

    async clearData() {
      this.clearStatus();
    },
  }),
};

export default CreateUserInOrganization;

